import React, { useState } from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import CategoryPage from '../pages/CategoryPage'
import Home from '../pages/Home'
// import Search from '../pages/Search'
function AppRoutes(props) {
	return (
		// <React.Suspense fallback={null}>

		<Router>
			<Routes>
				<Route exact path='/' element={<Home></Home>} />
				<Route exact path='/category/' element={<CategoryPage></CategoryPage>}></Route>
			</Routes>
		</Router>
		// {/* </React.Suspense> */}
	)
}

export default AppRoutes
